"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var Shortcuts_1 = __importDefault(require("../Shortcuts/Shortcuts"));
var shortcutHelpers_1 = require("../shortcutHelpers");
var sc = __importStar(require("./Section.styles"));
function Section(_a) {
    var section = _a.section;
    var i18n = useI18n_1.default();
    return (react_1.default.createElement(sc.Section, { key: section },
        section !== shortcutHelpers_1.SECTIONS.BUBBLY && (react_1.default.createElement(sc.SectionHeading, { level: 3, displayLevel: 5 }, i18n.t("global_navigation.keyboard_section_headers." + section))),
        react_1.default.createElement(Shortcuts_1.default, { section: section })));
}
Section.propTypes = {
    section: prop_types_1.default.oneOf(prop_types_1.default.string).isRequired,
};
exports.default = Section;
//# sourceMappingURL=Section.js.map